import {Fragment} from "preact";
import { 
    closeIcon,
    hamburguerIcon, 
} from "../../../assets";
import { useLoggedMenu } from "./useLoggedMenu";
import s from './loggedMenu.module.css';
import { useAppContext } from "../../../contexts";
import { Link } from "preact-router/match";

const LoggedMenu = () => {
    // Page logic data
    const pageProps = useLoggedMenu();

    const {highContrast} = useAppContext();

    // Destructured page logic data
    const {
        items,
        menuFocus,
        handleMenuFocus
    } = pageProps;

    // The font accessibility feature state
    const {accessibilityFont} = useAppContext();

    return (
        <Fragment>
            <div className={`absolute md:static pb-4 my-6`}>
                <ul className={'flex flex-col gap-[3px]'}>
                    <li className={`
                        ${menuFocus ? 'z-20 w-[10rem]' : 'w-[2.5rem]'} 
                        h-[2.5rem] bg-light-gray rounded p-[0.75rem] md:hidden
                        ${highContrast ? "highFormButtonSecond" : "bg-light-gray"}
                    `}>
                        <button onClick={handleMenuFocus} className={`flex justify-start items-center gap-[0.5rem]`}>
                            <img src={menuFocus ? closeIcon : hamburguerIcon} alt={"Hamburger icon"} />
                            <span 
                                className={menuFocus ? 'text-sabin-red-default font-bold font-museo' : 'hidden'} 
                                style={{fontSize: `${14 + accessibilityFont}px`}}
                            >
                                MINHA CONTA
                            </span>
                        </button>
                    </li>
                    {items.map((item) => {
                        return (
                            <li
                                key={item.href}
                                className={`
                                    ${menuFocus ? 'z-20 w-[10rem]' : 'w-[2.5rem]'} 
                                    select-none md:w-[10rem] h-[2.5rem] rounded p-[0.75rem]
                                    ${highContrast ? "highFormButtonSecond" : "bg-light-gray"}
                                `}
                            >
                                <Link href={item.href} className={`flex justify-start items-center gap-[0.5rem]`}>
                                    <img src={item.icon} alt={"Route icon image"} className={`${highContrast ? "blackImage" : ""}`}/>
                                    <span
                                        className={`font-museo ${menuFocus ? '' : 'hidden md:block'} ${highContrast ? "highLabelThird" : "text-[#666]"}` }
                                        style={{fontSize: `${14 + accessibilityFont}px`}}
                                    >
                                        {item.label}
                                    </span>
                                </Link>
                            </li>
                        )
                    })}
                </ul>
            </div>
            {/* Backdrop element */}
            <div
                className={s.backdrop + (menuFocus ? ` ${s.openBackdrop}` : "")}
                onClick={handleMenuFocus}
                data-testid="social-integration-backdrop"
            />
        </Fragment>
    )
}

export default LoggedMenu;
